export default __webpack_public_path__ + "static/media/me-icon-active.a3dfb94d.webp";